import { useState, useEffect } from 'react'
import './css/Paging.css'

import { MdOutlineCheck } from "react-icons/md";

export default function Paging({ number, show, setshow}) {
    
    const [checked, setchecked] = useState([])
    // useEffect(() => {
    //     let arr = [];
    //     Object.keys(answers)?.map((v, k) => {
    //         let c = answers[v];
    //         if (c) {
    //             let jCk = JSON.stringify(c);
    //             if (jCk?.length >= 3) {
    //                 arr.push(true);
    //             }
                
    //         }
    //     }); 
    //     setchecked(arr);
    // }, [answers])
    
    
    
    
    return (
        <div className='taskPagingBox'>
            {[...Array(number)].map((x, i) => { 
                return(
                    <>
                        {i ? <hr className={show >= i ? "ck" : "none"} /> : false}
                        <label className={show >= i ? "ck" : "none"} onClick={() => setshow(i)}>{i+1}</label>
                    </>
                );
                // console.log(number, i+1) 
            })}

            {/* <label className='ck'><MdOutlineCheck /></label>
            <hr className='ck'/>
            <label className='sel'>2</label>
            <hr />
            <label>3</label> */}
            
        </div>
    );
}
